import React from "react";
import Feature from "./Feature";

const FeaturesList = ({ features }) => {
  return (
    <div className="features-list">
      {features.map((feature, i) => {
        const { title, label, color, description, icon, image } = feature;
        const index = i + 1 < 10 ? `0${i + 1}` : i + 1;

        return (
          <Feature
            key={index}
            title={title}
            label={label}
            color={color}
            description={description}
            icon={icon}
            image={image}
            index={index}
          />
        );
      })}
    </div>
  );
};

export default FeaturesList;
